import { render } from "./pos-header.vue?vue&type=template&id=04b358c3"
import script from "./pos-header.vue?vue&type=script&lang=js"
export * from "./pos-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__